<template lang="pug">
    div
        header-component
        router-view
</template>
<script>
import HeaderComponent from '@/components/ContentLayout/HeaderComponent'
export default {
    name: 'ContentLayout', //nombre del componente
    components: {
        HeaderComponent
    },
    beforeMount() {
    },
    destroyed() {
    }
}
</script>